import "babel-polyfill";
import assembler from "@reduct/assembler";
import * as siteComponents from "./Components";
import * as sevenOfferPageNodeTypesComponents from "sevenOfferPageNodeTypes";
import * as sevenOfferPageReviewsComponents from "sevenOfferPageReviews";
import "./Components/carousels";

const app = assembler();
app.registerAll(siteComponents);
app.registerAll(sevenOfferPageNodeTypesComponents);
app.registerAll(sevenOfferPageReviewsComponents);

setTimeout(() => app.run(), 0);
document.addEventListener("Seven.Kurkumaplus.PageLoaded", app.run());

$(".hamburger").click(function () {
	$(this).toggleClass("is-active");
});
